function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#FDDE75"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3839:325)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.8061 22.7194C26.4277 21.6793 26.8401 20.3638 26.9201 19.0621C26.9708 18.2267 26.7847 17.3497 26.3816 16.525C25.7492 15.2295 24.6629 14.5017 23.6136 13.7986C22.8305 13.2739 22.0904 12.7785 21.5673 12.0707L21.4734 11.9446C21.1642 11.5291 20.8149 11.0583 20.7595 10.6629C20.7041 10.2629 20.341 9.97823 19.9441 10.0013C19.5409 10.029 19.2286 10.3629 19.2286 10.7675V24.4764C18.5839 24.0856 17.79 23.8456 16.9207 23.8456C14.8005 23.8456 13.0742 25.2257 13.0742 26.9228C13.0742 28.6199 14.8005 30 16.9207 30C19.0409 30 20.7672 28.6199 20.7672 26.9228V17.9559C21.9227 18.3974 23.8136 19.5222 24.3337 22.1485C24.2368 22.2916 24.1444 22.4455 24.0367 22.5686C23.7552 22.8871 23.7859 23.3733 24.106 23.6533C24.4229 23.9364 24.9091 23.9026 25.1907 23.5841C25.3969 23.3502 25.5799 23.0763 25.7553 22.7901C25.7738 22.7686 25.7908 22.7455 25.8061 22.7194Z",
  fill: "#84CDBD"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3839:325"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(10 10)"
})));

var SvgAttendanceIcon = function SvgAttendanceIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttendanceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attendance-icon.eda50d2a.svg";
export { ForwardRef as ReactComponent };